export enum ErrorCode {
    NotDefinedError = 'NotDefinedError',
    SoldeInsuffisant = 'soldeInsuffisant', // Code FO,
    SoldeComptableInsuffisant = 'soldeComptableInsuffisant',
    SoldeBancaireInsuffisant = 'soldeBancaireInsuffisant',
    SoldeSuffisantInsuffisant = 'soldeSuffisantInsuffisant', // Code Insuffisant
    FacteurRisqueBlocked = 'facteurRisqueBlocked',
    FacteurRisqueNotVerified = 'facteurRisqueNotVerified',
    FacteurRisqueKO = 'facteurRisqueKO',
    MissedDocumentsToSubmit = 'missedDocumentsToSubmit',
    BankAccountLockedByAnotherUser = 'bankAccountLockedByAnotherUser',
    GenerationAndConsultationLotLockedByAnotherUser = 'generationAndConsultationLotLockedByAnotherUser',
    CalculDateOperationImpossible = 'calculDateOperationImpossible',
    InvalidNumeroAffaireException = 'invalidNumeroAffaireException',
    MissingSignatureActive = 'missingSignatureActive',
    MissingSignatureActiveCabinet = 'missingSignatureActiveCabinet',
    CompteNotFoundException = 'compteNotFoundException',
    AffectOperationAValiderException = 'affectOperationAValiderException',
    AffectOperationAValiderAlreadyLockedException = 'affectOperationAValiderAlreadyLockedException',
    SelectionTierAlreadyLocked = 'selectionTierAlreadyLocked',
    OperationSoumittedException = 'operationSoumittedException',
    OperationSoumiseNonEnregistrableException = 'operationSoumiseNonEnregistrableException',
    OperationRefusedException = 'operationRefusedException',
    DuplicateCodeException = 'duplicateCode',
    ParametreGeneriqueException = 'parametreGeneriqueException',
    PermissionDenied = 'permissionDenied',
    OperationAffectedToOtherUser = 'operationAffectedToOtherUser',
    FacteurRisqueBlocking = 'facteurRisqueBlocking',
    EntityInUse = 'entityInUse',
    ModeReceptionDefault = 'modeReceptionDefault',
    LastAdminEmdfDeletionAttemptException = 'lastAdminEmdfDeletionAttemptException',
    PermissionAntagoniste = 'permissionAntagoniste',
    RetraitVirementSansRib = 'retraitVirementSansRib'
}

export enum FailureFunction {
	CreateAffaireRetraitFailure = 'CreateAffaireRetraitFailure',
	CreateAffaireDepotFailure = 'CreateAffaireDepotFailure',
	CreateAffaireRibFailure = 'CreateAffaireRibFailure',
	UpdateAffaireDepotFailure = 'UpdateAffaireDepotFailure',
	UpdateAffaireRetraitFailure = 'UpdateAffaireRetraitFailure',
	UpdateAffaireRibFailure = 'UpdateAffaireRibFailure',
	DeleteAffaireDepotFailure = 'DeleteAffaireDepotFailure',
	DeleteAffaireRetraitFailure = 'DeleteAffaireRetraitFailure',
	DeleteDepotCurrentAffaireFailure = 'DeleteDepotCurrentAffaireFailure',
	DeleteRetraitCurrentAffaireFailure = 'DeleteRetraitCurrentAffaireFailure',
	UpdateAffaireFailure = 'UpdateAffaireFailure',
	SubmitSaisieFailure = 'SubmitSaisieFailure',
	DeleteDepotLineFailure = 'DeleteDepotLineFailure',
	DeleteRetraitLineFailure = 'DeleteRetraitLineFailure',
	CreateRetraitLineFormFailure = 'CreateRetraitLineFormFailure',
	UpdateDepotLineFailure = 'UpdateDepotLineFailure',
	UpdateRetraitLineFailure = 'UpdateRetraitLineFailure',
	DeleteOperationFailure = 'DeleteOperationFailure',
	SubmitCarpaFailure = 'SubmitCarpaFailure',
	UpdateOperationEnregistreeFailure = 'UpdateOperationEnregistreeFailure',
	DeleteLotFailure = 'DeleteLotFailure',
	AffectOperationsFailure = 'AffectOperationsFailure',
	AffectOperationsLockedFailure = 'AffectOperationsLockedFailure',
	ValideCurrentOperationAValideFailure = 'ValideCurrentOperationAValideFailure',
    AcceptOperationsHistoriqueFailure= 'AcceptOperationsHistoriqueFailure'
}

export enum TypeAction {
    Creation = 'Saisie',
    Modification = 'Modification',
    Suppression = 'Suppression',
    Enregistrement = 'Enregistrement',
    None = 'Solde Débiteur',
    Affectation = 'Affectation',
    AlreadyAffected = 'Affectation opération(s)',
    LockedOperationToValidate = 'Affectation opération',
    LockedTierToSelect = 'Séléction Impossible',
    Validation = "Validation d'une opération",
    Refus = 'Refus',
    Unpaid = 'Impayé',
    Reject = 'Rejet',
    Annulation = 'Annulation',
    Annulation15 = 'Annulation15',
    Renvoi = 'Renvoie',
    Accepter = 'Accepter',
    DeblocageCompte = 'Déblocage',
    VirementRecu = 'Virement reçu',
    SuppressionImpossible = "Suppression impossible d'un mode de réception",
    SoumissionImpossible = "Soumission impossible"

}
